<template>
  <div class="villageSurvey">
    <div class="titleWrap">
      <div class="setTitle">小区概览</div>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <el-select class="villageSelect" v-model="villageValue" filterable clearable size="small" placeholder="小区名称">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-select class="provinceSelect" v-model="provinceValue" filterable clearable size="small" placeholder="省份" @change="changeProvince">
        <el-option v-for="item in provinceList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <div class="villageTotal">共 <span class="number">{{ villageTotal }}</span> 个小区</div>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-row class="myRow">
        <el-col :xl="6" :lg="8" :md="8" :sm="12" :xs="12" class="mycol addCol" v-if="funcData.indexOf('add') > -1">
          <div class="contentWrap" @click="addVillage">
            <div class="addBtn"></div>
            <div class="title">新增小区</div>
          </div>
        </el-col>
        <el-col :xl="6" :lg="8" :md="8" :sm="12" :xs="12" class="mycol" v-for="item in villageAttr" :key="item.id">
          <div class="contentWrap" @click="detail(item.id, item.orgName, item.address, item.orgCode)">
            <div class="villageName">{{ item.orgName }}</div>
            <div class="villageAddress">{{ item.address }}</div>
            <div class="contentModle" style="border-bottom: 1px dashed #efefef;">
              <div class="contentDiv">
                <div class="contentImg villageImg"></div>
                <div class="contentNumber">{{ item.countBuilding }}</div>
                <div class="contentExplain">楼宇(栋)</div>
              </div>
              <div class="contentDiv">
                <div class="contentImg liftImg"></div>
                <div class="contentNumber">{{ item.countLiftBase }}</div>
                <div class="contentExplain">电梯(台)</div>
              </div>
              <div class="contentDiv">
                <div class="contentImg userImg"></div>
                <div class="contentNumber">{{ item.countOwner }}</div>
                <div class="contentExplain">住户(人)</div>
              </div>
            </div>
            <div class="contentModle" style="margin-top: 16px; margin-bottom: 10px;">
              <!-- <div class="contentDiv">
                <div class="contentTitle">年检(台)：</div>
                <div class="contentValue">{{ item.njNum }}</div>
              </div> -->
              <div class="contentDiv">
                <div class="contentTitle">一梯一档(份)：</div>
                <div class="contentValue">{{ item.countFile }}</div>
              </div>
            </div>
            <!-- <div class="contentModle">
              <div class="contentDiv">
                <div class="contentTitle">保养(台)：</div>
                <div class="contentValue">{{ item.byNum }}</div>
              </div>
            </div> -->
          </div>
        </el-col>
      </el-row>
    </el-main>
    <!-- 新增小区弹出层 -->
    <el-dialog :visible.sync="dialog" :title="title" width="500px" :close-on-click-modal="false" @close="notBtn">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="小区名称" prop="villageName">
          <el-input v-model.trim="form.villageName" placeholder="小区名称"></el-input>
        </el-form-item>
        <el-form-item label="小区编码" required>
          <el-col :span="6">
            <el-form-item prop="uid1" style="margin-bottom: 10px;">
              <el-input v-model.trim="form.uid1" :maxLength="3" placeholder="UID1"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="3">-</el-col>
          <el-col :span="6">
            <el-form-item prop="uid2" style="margin-bottom: 10px;">
              <el-input v-model.trim="form.uid2" :maxLength="3" placeholder="UID2"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="3">-</el-col>
          <el-col :span="6">
            <el-form-item prop="uid3" style="margin-bottom: 10px;">
              <el-input v-model.trim="form.uid3" :maxLength="3" placeholder="UID3"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="省" prop="province">
          <el-select v-model="form.province" filterable clearable placeholder="省" @change="changeFormProvince">
            <el-option v-for="item in form.provinceList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" prop="city">
          <el-select v-model="form.city" filterable clearable placeholder="市" @change="changeFormCity">
            <el-option v-for="item in form.cityList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区" prop="district">
          <el-select v-model="form.district" filterable clearable placeholder="区" @change="changeFormDistrict">
            <el-option v-for="item in form.districtList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" prop="area">
          <el-input v-model.trim="form.area" placeholder="详细地址"></el-input>
        </el-form-item>
        <el-form-item label="写卡器终端" prop="cardSN">
          <el-input v-model.trim="form.cardSN" placeholder="写卡器终端"></el-input>
        </el-form-item>
        <el-form-item label="扇区" prop="sector">
          <el-input v-model.trim="form.sector" placeholder="扇区"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input v-model.trim="form.userName" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model.trim="form.password" :disabled="true" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="personName">
          <el-input v-model.trim="form.personName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model.trim="form.phone" placeholder="联系方式" :maxLength="11"></el-input>
        </el-form-item>
        <el-form-item label="收费情况" prop="charge">
          <el-select v-model="form.charge" filterable clearable placeholder="收费情况">
            <el-option v-for="item in form.chargeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notBtn">取 消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="okBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'VillageSurvey',
  data () {
    return {
      villageTotal: 0, // 小区总数
      provinceValue: '', // 省份下拉菜单选中value
      provinceList: [], // 省份下拉菜单
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      villageAttr: [], // 小区列表
      dialog: false, // 小区弹出层状态
      title: '', // 小区弹出层标题
      loading: false, // 小区弹出层确定按钮loading
      form: {
        villageId: '', // 小区Id
        villageName: '', // 小区名称
        villageCode: '', // 小区编码
        uid1: '', // UID1
        uid2: '', // UID2
        uid3: '', // UID3
        province: '', // 省份下拉菜单选中value
        provinceName: '', // 省份下拉菜单选中name
        provinceList: [], // 省份下拉菜单
        city: '', // 城市下拉菜单选中value
        cityName: '', // 城市下拉菜单选中name
        cityList: [], // 城市下拉菜单
        district: '', // 行政区下拉菜单选中value
        districtName: '', // 行政区下拉菜单选中name
        districtList: [], // 行政区下拉菜单
        area: '', // 详细地址
        longitude: '', // 经度
        latitude: '', // 维度
        cardSN: '', // 写卡器终端
        sector: '', // 扇区
        userName: '', // 用户名
        password: '', // 密码
        personName: '', // 联系人
        phone: '', // 联系方式
        charge: '', // 收费情况下拉菜单选中value
        chargeList: '' // 收费情况下拉菜单
      },
      rules: {
        villageName: [
          {
            required: true,
            message: '请输入小区名称',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[\u4e00-\u9fa5\x21-\x7E]+$/
              if (!reg.test(value)) {
                callback(new Error('小区名称由中英文字符、数字及特殊符号组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        uid1: [
          {
            required: true,
            message: '请输入UID',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value) || value.length !== 3) {
                callback(new Error('UID由3位数字组成'))
              } else {
                if (Number(value) > 255) {
                  callback(new Error('UID范围为000~255'))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        uid2: [
          {
            required: true,
            message: '请输入UID',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value) || value.length !== 3) {
                callback(new Error('UID由3位数字组成'))
              } else {
                if (Number(value) > 255) {
                  callback(new Error('UID范围为000~255'))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        uid3: [
          {
            required: true,
            message: '请输入UID',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value) || value.length !== 3) {
                callback(new Error('UID由3位数字组成'))
              } else {
                if (Number(value) > 255) {
                  callback(new Error('UID范围为000~255'))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        province: [
          {
            required: true,
            message: '请选择省份',
            trigger: 'change'
          }
        ],
        city: [
          {
            required: true,
            message: '请选择城市',
            trigger: 'change'
          }
        ],
        district: [
          {
            required: true,
            message: '请选择行政区',
            trigger: 'change'
          }
        ],
        area: [
          {
            required: true,
            message: '请输入详细地址',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('详细地址由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        cardSN: [
          {
            required: true,
            message: '请输入终端序列号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z]+$/
              if (!reg.test(value)) {
                callback(new Error('终端序列号由英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        sector: [
          {
            required: true,
            message: '请输入扇区',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9]+$/
              if (!reg.test(value)) {
                callback(new Error('扇区由数字组成'))
              } else {
                if (Number(value) > 16 || Number(value) < 1) {
                  callback(new Error('扇区范围是1~16'))
                } else {
                  callback()
                }
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        userName: [
          {
            required: true,
            message: '请输入用户名',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('用户名由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z_]+$/
              if (!reg.test(value)) {
                callback(new Error('密码由英文字符、数字及下划线组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        personName: [
          {
            required: true,
            message: '请输入联系人',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('联系人由中英文字符及数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入联系方式',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                callback(new Error('请输入正确的联系方式'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        charge: [
          {
            required: true,
            message: '请选择收费情况',
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    // 功能权限
    funcData () {
      let data = this.$store.state.menus.funcData
      let buttonArr = []
      for (let i = 0; i < data.length; i++) {
        if (data[i].url === this.$store.state.menus.activeMenu) {
          buttonArr.push(data[i].funcBotton)
        }
      }
      return JSON.parse(JSON.stringify(buttonArr))
    }
  },
  mounted () {
    // 判断是否为物业管理员
    if (this.$store.state.user.villageId !== '') {
      this.$router.push('villageDetail?id=' + this.$store.state.user.villageId + '&villageName=' + encodeURI(encodeURI(this.$store.state.user.villageName)) + '&villageAddress=' + encodeURI(encodeURI(this.$store.state.user.villageAddress)) + '&villageCode=' + this.$store.state.user.dlevelcode)
    }

    // 获取有效省份列表
    this.$http.get(this.$api.map_province_list).then((res) => {
      let data = res.data

      if (data.success) {
        this.provinceList = data.data
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })

    // 获取省市区下拉框数据
    for (let i in this.$province) {
      // 省份
      this.form.provinceList.push({
        key: i,
        value: this.$province[i]
      })
    }

    // 收费情况
    this.form.chargeList = [
      {
        key: 0,
        value: '不收费'
      },
      {
        key: 1,
        value: '收费'
      }
    ]

    // 获取小区名称下拉菜单
    this.getVillageSelect()
    // 获取小区列表
    this.getVillageList()
  },
  methods: {
    search () {
      this.getVillageList()
    },
    getVillageSelect () {
      this.$http.get(this.$api.village_list, {
        params: {
          pageSize: 9999,
          pageNum: 1,
          province: this.provinceValue
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.villageList = data.data.list
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    changeProvince () {
      this.villageValue = ''
      this.getVillageSelect()
    },
    changeFormProvince (val) {
      this.form.city = ''
      this.form.district = ''
      this.form.cityList = []
      this.form.districtList = []
      if (val !== '') {
        for (let i in this.$city) {
          if (i.substr(0, 2) === val.substr(0, 2)) {
            this.form.cityList.push({
              key: i,
              value: this.$city[i]
            })
          }
        }
        for (let i = 0; i < this.form.provinceList.length; i++) {
          if (this.form.provinceList[i].key === val) {
            this.form.provinceName = this.form.provinceList[i].value
          }
        }
      }
    },
    changeFormCity (val) {
      this.form.district = ''
      this.form.districtList = []
      if (val !== '') {
        for (let i in this.$county) {
          if (i.substr(0, 4) === val.substr(0, 4)) {
            this.form.districtList.push({
              key: i,
              value: this.$county[i]
            })
          }
        }
        for (let i = 0; i < this.form.cityList.length; i++) {
          if (this.form.cityList[i].key === val) {
            this.form.cityName = this.form.cityList[i].value
          }
        }
      }
    },
    changeFormDistrict (val) {
      if (val !== '') {
        for (let i = 0; i < this.form.districtList.length; i++) {
          if (this.form.districtList[i].key === val) {
            this.form.districtName = this.form.districtList[i].value
          }
        }
      }
    },
    getVillageList () {
      this.$http.get(this.$api.village_list, {
        params: {
          province: this.provinceValue,
          orgId: this.villageValue,
          pageNum: 1,
          pageSize: 9999
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.villageAttr = data.data.list
          this.villageTotal = data.data.total
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    addVillage () {
      this.dialog = true
      this.title = '新增小区'
      this.form.password = '123456'
    },
    detail (id, name, address, orgCode) {
      this.$router.push('villageDetail?id=' + id + '&villageName=' + encodeURI(encodeURI(name)) + '&villageAddress=' + encodeURI(encodeURI(address)) + '&villageCode=' + orgCode)
    },
    notBtn () {
      this.loading = false
      this.form.villageId = ''
      this.form.cityList = []
      this.form.districtList = []
      this.$refs.form.resetFields()
      this.dialog = false
    },
    okBtn () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$jsonp('https://apis.map.qq.com/ws/geocoder/v1', {
            address: this.form.provinceName + this.form.cityName + this.form.districtName + this.form.area,
            key: 'XRKBZ-WS26D-KDY4E-POSNQ-PEIEE-MQBUD',
            output: 'jsonp'
          }).then(res => {
            if (res.status === 0) {
              this.form.longitude = res.result.location.lng
              this.form.latitude = res.result.location.lat
            } else {
              this.$message({
                type: 'error',
                message: res.message,
                duration: 1000
              })
            }
            this.saveVillage()
          }).catch(err => {
            console.log(err)
            this.saveVillage()
          })
        } else {
          return false
        }
      })
    },
    saveVillage () {
      this.form.villageCode = this.form.uid1 + this.form.uid2 + this.form.uid3
      let formData = new FormData()
      formData.append('orgName', this.form.villageName)
      formData.append('orgCode', this.form.villageCode)
      formData.append('pCode', this.form.province)
      formData.append('province', this.form.provinceName)
      formData.append('cCode', this.form.city)
      formData.append('city', this.form.cityName)
      formData.append('counCode', this.form.district)
      formData.append('county', this.form.districtName)
      formData.append('address', this.form.area)
      formData.append('writer', this.form.cardSN)
      formData.append('sector', this.form.sector)
      formData.append('account', this.form.userName)
      formData.append('password', this.form.password)
      formData.append('name', this.form.personName)
      formData.append('phone', this.form.phone)
      formData.append('charge', this.form.charge)
      formData.append('longitude', this.form.longitude)
      formData.append('latitude', this.form.latitude)

      this.$http({
        method: 'post',
        url: this.$api.village_add,
        data: formData
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.$message({
            message: '新增小区成功',
            type: 'success',
            duration: 1000
          })
          this.notBtn()
          this.getVillageList()
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
          this.loading = false
        }
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.villageSurvey
  box-sizing border-box
  padding 80px 0 0
  width 100%
  min-height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .villageTotal
      float right
      margin-right 20px
      height 32px
      line-height 32px
      font-size 14px
      color #333
      .number
        color #F02B54
    .provinceSelect
      float right
      margin-right 20px
      width 100px
    .villageSelect
      float right
      margin-right 20px
      width 160px
    .searchBtn
      float right
      margin-right 20px
      padding 5.5px 6px
      font-size 18px
  .tableWrap
    box-sizing border-box
    padding 0
    border-radius 4px
    .myRow
      box-sizing border-box
      padding-right 20px
      padding-bottom 20px
      overflow hidden
      .mycol
        box-sizing border-box
        margin-top 20px
        padding-right 20px
        min-width 360px
        .contentWrap
          box-sizing border-box
          position relative
          margin-left 20px
          padding 20px 20px 0
          width 100%
          height 264px
          background-color #fff
          box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
          border-radius 4px
          cursor pointer
          &:hover
            box-shadow 0 3px 10px 0 rgba(31, 145, 243, .4)
          .villageName
            line-height 20px
            font-size 16px
            color #333
            font-weight bold
          .villageAddress
            margin 8px 0
            line-height 16px
            font-size 12px
            color #666
          .contentModle
            display flex
            .contentDiv
              flex 1
              .contentImg
                margin 0 auto
                width 56px
                height 56px
                background-repeat no-repeat
                background-size 100% 100%
                &.villageImg
                  background-image url('../../assets/img/village_color.png')
                &.liftImg
                  background-image url('../../assets/img/lift_color.png')
                &.userImg
                  background-image url('../../assets/img/user_color.png')
              .contentNumber
                line-height 24px
                font-size 20px
                font-weight bold
                color #333
                text-align center
              .contentExplain
                margin-bottom 32px
                line-height 16px
                font-size 12px
                color #666
                text-align center
              .contentTitle
                display inline-block
                width max-content
                line-height 16px
                font-size 12px
                color #666
              .contentValue
                display inline-block
                line-height 16px
                font-size 12px
                font-weight bold
                color #333
        &.addCol
          .contentWrap
            padding-top 86px
            text-align center
            .addBtn
              margin 0 auto
              width 40px
              height 40px
              background-image url('./add_40.png')
              background-repeat no-repeat
              background-size 100% 100%
            .title
              margin-top 32px
              line-height 18px
              font-size 14px
              color #60ACFC
  &>>>.el-dialog
    .el-dialog__header
      border-bottom 1px solid #eee
    .el-dialog__body
      max-height 300px
      overflow auto
      .el-form
        width 350px
        .el-select
          width 100%
        .line
          text-align center
</style>



// WEBPACK FOOTER //
// src/components/village/villageSurvey.vue